"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _responsiveProps = require("../../../internal/responsiveProps");
var _formatting = require("../../../internal/formatting");
var _tokens = require("../../../tokens");
var _Wrapper = _interopRequireDefault(require("../../Wrapper"));
var _GridItem = _interopRequireDefault(require("../GridItem"));
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
const dividerOutput = _ref => {
  let {
    columns = _tokens.GRID_COLUMNS_DEFAULT,
    dividerSize = _tokens.GRID_DIVIDER_SIZE_DEFAULT
  } = _ref;
  return values => {
    const inserts = values.sort((a, b) => b - a); // sort in decreasing order
    const templateColumns = Array.from({
      length: columns
    }, () => '1fr');
    inserts.forEach(insert => templateColumns.splice(insert, 0, dividerSize));
    return `grid-template-columns: ${templateColumns.join(' ')};`;
  };
};
const StyledGrid = (0, _styledComponents.default)(props => /*#__PURE__*/_react.default.createElement(_Wrapper.default, _extends({
  omitProps: {
    keys: ['columns', 'dividerSize'],
    responsiveKeys: ['gap', 'dividerAtColumn']
  }
}, props))).withConfig({
  displayName: "StyledGrid",
  componentId: "sc-1ua5lmp-0"
})(["display:flex;flex-wrap:wrap;display:grid;grid-auto-flow:dense;grid-template-columns:repeat(", ",1fr);", " ", ""], _ref2 => {
  let {
    columns
  } = _ref2;
  return columns;
}, props => (0, _responsiveProps.responsiveCssProps)({
  props: Object.assign(props.container ? {
    gapFromM: _tokens.CONTAINER_GRID_GAP_AT_BP.M,
    gapFromL: _tokens.CONTAINER_GRID_GAP_AT_BP.L
  } : {}, props),
  propName: 'gap',
  cssProperty: 'grid-gap',
  formatValues: _formatting.formatGtrValues
}), props => (0, _responsiveProps.responsiveCssProps)({
  props: props,
  propName: 'dividerAtColumn',
  joinValues: values => typeof values === 'object' ? values : [values],
  output: dividerOutput(props)
}));

/**
## Usage

```jsx
import { Grid } from '@farewill/ui'

() => (
  <Grid>
    <Grid.Item />
  </Grid>
)
```

## Notes

`<Grid>` extends from `<Wrapper>` so can use any of `<Wrapper>`’s styling functionality, notably `container`. Setting `container` changes the default gaps to match the page padding.
 */
const Grid = _ref3 => {
  let {
    children,
    columns = _tokens.GRID_COLUMNS_DEFAULT,
    gap = _tokens.GRID_GAP_DEFAULT,
    dividerSize = _tokens.GRID_DIVIDER_SIZE_DEFAULT,
    ...props
  } = _ref3;
  return /*#__PURE__*/_react.default.createElement(StyledGrid, _extends({
    columns: columns,
    gap: gap,
    dividerSize: dividerSize
  }, props), children);
};
Grid.Item = _GridItem.default;
var _default = exports.default = Grid;